import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/** Pushes the team's changed variants to the `redohsa.eligibility` metafield now, or joins the running push. */
export const startHsaMetafieldPush = {
  name: "startHsaMetafieldPush" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ workflowId: z.string() }),
};
